// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__EGId6","icon_size_24":"styles_icon_size_24__PWVcg","icon_fill":"styles_icon_fill__ESb1k"};